
// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import { Grid, Icon, Modal, Input } from "@mui/material";

import { Link, useNavigate } from "react-router-dom";
import { CSVLink } from "react-csv";

import SoftAlert from "components/SoftAlert";

import DataTableExtensions from 'react-data-table-component-extensions';
import 'react-data-table-component-extensions/dist/index.css';
import DataTable from 'react-data-table-component';

import { useEffect, useState } from "react";
import { processHeadersCatalogs, processHeadersCatalogsCsv } from "tools/helpers";
import { CheckBox, EditNote } from "@mui/icons-material";
import { KEY_USER } from "constans";
import SoftInput from "components/SoftInput";
import { insertDataJson, validateForm } from "tools/helpers";

function Participants( {data, label, setOpen, formData, confirmRegister, confirmGafete, setOpenDataParticipant, setDataParticipant, confirmDelete, downloadPDFGafete, listaBusqueda, actualizaStateBusqueda, campobusca, event_id}) {
  const [userData, setUserData] = useState(JSON.parse(localStorage.getItem(KEY_USER)));
  const [columns, setColumns] = useState([]);
  const [columnsCSV, setColumnsCSV] = useState([]);
  const [openEmail, setOpenEmail] = useState(false);

  const emptyData = {
    date_ini : '',
    date_end : ''
  }

  const [formDataEmail, setFormDataEmail] = useState(emptyData);
  const [statusForm, setStatusForm] = useState({status: null, message: ""});
  const [errorFields, setErrorsFields] = useState([]);

    const defaultColumns = [
    {
      name: 'Tipo',
      selector: row => row.type_visitor,
      compact: true
    },
    {
      name: 'Nombre',
      selector: row => <Link size="h5" onClick={()=>downloadPDFGafete(row)} >{row.name}</Link> ,
       width: '250px'
    },
    {
      name: 'Correo',
      selector: row => row.email,
      width: '200px'
    },
    {
    name: 'Teléfono',
    selector: row => row.phone,
    compact: true
    },
    {
      name: 'Profesión',
      selector: row => row.position,
      compact: true
    },
    {
      name: 'Cupón',
      selector: row => row.coupon,
      compact: true
    },
    {
      name: 'Costo',
      selector: row => row.cost,
      compact: true
    },
    {
      name: 'No. Membresía',
      selector: row => row.membership,
      compact: true
    },
  ];

    const columnApprove = [
    {
      name: 'Gafete',
      selector: row => <CheckBox onClick={()=>confirmGafete(row)} style={{ cursor: "pointer"}} fontSize="medium" color={`${row.gafete === 'true' ? 'success' : 'default'}`}>delete</CheckBox>,
      compact: true
    },
    {
      name: 'Editar',
      selector: row => <EditNote onClick={()=>{
        setOpenDataParticipant(true);
        setDataParticipant(row);
      }} style={{ cursor: "pointer"}} fontSize="medium" color="error">delete</EditNote>,
      compact: true
    },
    {
      name: 'Validar',
      selector: row => <CheckBox onClick={()=>confirmRegister(row)} style={{ cursor: "pointer"}} fontSize="medium" color={`${parseInt(row.status) === 1 ? 'success' : 'default'}`}>delete</CheckBox>,
      compact: true
    },
    {
      name: 'Recordado',
      selector: row => <CheckBox fontSize="medium" color={`${row.reminder === 'true' ? 'success' : 'default'}`}>delete</CheckBox>,
      compact: true
    },
    {
      name: '',
      selector: row => userData.type === 'admin' ? <Icon  onClick={()=>confirmDelete(row, 'Register')} style={{ cursor: "pointer"}} fontSize="medium" color="error">delete</Icon> : null,
      compact: true
      },
  ];

  const defaultColumnsCSV = [
    {key: "type_visitor", label: "Tipo" },
    {key: "name", label: "Nombre" },
    {key: "phone", label: "Teléfono" },
    {key: "email", label: "Correo" },
    {key: "cost", label: "Costo" },
    {key: "gafete", label: "Gafete" },
    {key: "status", label: "Validado" },
    {key: "position", label: "Profesión" },
    {key: "coupon", label: "Cupón" },
    {key: "membership", label: "No. membresía" },
    {key: "bussiness_name", label: "Razón social" },
    {key: "rfc", label: "RFC" },
    {key: "address", label: "Dirección fiscal" },
    {key: "cfdi", label: "Uso de CFDI" },
    {key: "regime", label: "Régimen" },
    {key: "created_at", label: "Fecha registro" },
  ];

  const processHeadersData =(headers) =>{
    const newList = processHeadersCatalogs(headers);
    const newListCSV = processHeadersCatalogsCsv(headers);
    setColumns([...defaultColumns, ...newList, ...columnApprove]);
    setColumnsCSV([...defaultColumnsCSV, ...newListCSV]);
  }

    useEffect(()=>{
      processHeadersData(data.headers);
    },[data])


    const setState = (e) => {
      setFormDataEmail({
        ...formDataEmail,
        [e.target.name]: e.target.value,
      });
    };

    const requiredFields = ['date_ini', 'date_end'];
    const sendForm = async() =>{
      const isValidDateRange = new Date(formDataEmail.date_ini) < new Date(formDataEmail.date_end);
      if (!isValidDateRange) {
        setErrorsFields(['date_ini', 'date_end']);
        return;
      }

      const validationErrors = validateForm(formDataEmail, requiredFields);
      setErrorsFields(validationErrors);
      if(validationErrors.length > 0)
      {
        return;
      }

      setStatusForm({status: true, message: "Eviando..."});
      const route = `Email-Reminder`;
      console.log(event_id)
      const newData = {
        ...formDataEmail,
        event_id: event_id
      }
  
      const send = await insertDataJson(route, newData);  
  
      if (send.code === 200) {
        setStatusForm({
          status: true,
          message: "Se han enviado los recordatorios satisfactoriamente",
          label: "success",
        });
        setFormDataEmail(emptyData);
        return;
      }

      if (send.status === "error") {
        setStatusForm({
          status: true,
          message: send.message ?? "Ha ocurrido algo, intente de nuevo",
          label: "warning",
        });
        return;
      }
  
      setStatusForm({
        status: true,
        message: "Ha ocurrido algo, intente de nuevo",
        label: "error",
      });
    }
    
    return(
      <SoftBox sx={8} md={12}>
        <Grid container p={1}>
        <Grid container item md={12}>
          <Grid item md={4}>
              <SoftTypography variant="h5" fontSize={18}>{label} </SoftTypography>
          </Grid>
          <Grid item container md={8} justifyContent="flex-end">
            <SoftButton
                md={6}
                variant="gradient"
                color= "primary"
                size="medium"
                style = {{ marginRight: 5, margin: 3 }}
                onClick = {()=>{
                  const domain = window.location.hostname;
                  window.open(`/register/${formData.slug}/1`, '_blank');
                }}
              >
                Registro General
            </SoftButton>
            <SoftButton
                md={12}
                variant="gradient"
                color= "success"
                size="medium"
                style = {{ margin: 3  }}
              >
                {
                  listaBusqueda ?
                    <CSVLink data={listaBusqueda} headers={columnsCSV} filename={`Participantes_${formData.name}.csv`} style={{color: 'white'}}>Descargar Excel</CSVLink>
                  : null
                }
            </SoftButton>
            <SoftButton
                md={6}
                variant="gradient"
                color= "info"
                size="medium"
                style = {{ marginRight: 20,  margin: 3  }}
                onClick = {()=>setOpenEmail(true)}
              >
                <Icon style={{ marginRight: 5 }}  fontSize="medium"  >mail</Icon>
                Envíar recordatorio
            </SoftButton>
          </Grid>
            <SoftInput onChange={actualizaStateBusqueda} value={campobusca} placeholder="Escriba un Tipo, Nombre, Email, Profesión" />
        </Grid>
        <Grid md={12}>
          <DataTableExtensions
            columns={columns}
            data={listaBusqueda}
            export={false}
            print={false}
            filter={false}
            filterPlaceholder="Buscar..."
          >
            <DataTable
              columns={columns}
              data={listaBusqueda}
              pagination
              paginationComponentOptions={{
                rowsPerPageText: 'Registros por página:', 
                rangeSeparatorText: 'de', 
                noRowsPerPage: false, 
                selectAllRowsItem: true, 
                selectAllRowsItemText: 'Todos',
              }}
              paginationPerPage={20}
              noDataComponent={<SoftBox py={5}>No se han encontrado resultados.</SoftBox>}
            />
          </DataTableExtensions>
        </Grid>
      </Grid>
      <Modal
          open={openEmail}
          onClose={()=>setOpenEmail(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
        <SoftBox sx={styleForm} md={12}>
          <Grid md={12} xs={12} mt={1} spacing={2} p={5} justifyContent='center' container>
            <SoftTypography fontSize={12} p={0} color="white" mb={2}>
              Se enviará un correo recordatorio a los participantes que se registraron dentro de las siguientes fechas.
            </SoftTypography>
            <Grid xs={6} md={6} px={1}>
              <SoftTypography variant="caption">Fecha inicio promoción *:</SoftTypography>
              <Input 
                type = "date"
                name = "date_ini"
                value = {formDataEmail.date_ini}
                onChange={setState}
                className= {errorFields.includes("date_ini") ? 'error-field' : null}
              />
            </Grid>
            <Grid xs={6} md={6} px={1}>
              <SoftTypography variant="caption">Fecha fin promoción *:</SoftTypography>
              <Input 
                type = "date"
                name = "date_end"
                value = {formDataEmail.date_end}
                onChange={setState}
                className= {errorFields.includes("date_end") ? 'error-field' : null}
              />
            </Grid>
            <Grid container spacing={2} p={5} justifyContent='flex-end'>
                <Grid item >
                  <SoftButton
                    md={6}
                    variant="gradient"
                    color= "primary"
                    size="medium"
                    onClick = {()=>sendForm()}
                  >
                    Envíar
                  </SoftButton>
                </Grid>
                <Grid item >
                  <SoftButton
                    md={6}
                    variant="gradient"
                    color= "dark"
                    size="medium"
                    onClick = {()=>setOpenEmail(false)}
                  >
                    Cancelar
                  </SoftButton>
                </Grid>
            </Grid>
            <Grid md={12} justifyContent='center' container>
            {
                statusForm.status ? (
                  <SoftBox style={{ width: '100%'}} extAlign="center" p={1}>
                    <SoftAlert color={statusForm.label}> 
                      <SoftTypography fontSize={12} p={0} color="white"  fontWeight="medium">
                        {statusForm.message}
                      </SoftTypography>
                    </SoftAlert>
                  </SoftBox>
                ): null
              }
            </Grid>
          </Grid>
        </SoftBox>
      </Modal>
    </SoftBox>
    )
  
}

const styleForm = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '50%',
  height: '400px',
  maxWidth: '800px',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
};

export default Participants;